import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-signup-submit',
  templateUrl: './signup-submit.component.html',
  styleUrls: ['./signup-submit.component.scss']
})
export class SignupSubmitComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
